<script setup lang="ts">
import { steps } from '../data/landing.content'
import { useLandingScroll } from '../composables/useLandingScroll'

const { registerReveal } = useLandingScroll()
</script>

<template>
  <section class="wl-como-funciona" id="como-funciona">
    <div class="container">
      <div class="section-head reveal" :ref="registerReveal">
        <div class="section-tag">Proceso</div>
        <h2 class="section-title">Así de fácil es <span class="gradient-text">comenzar</span></h2>
        <p class="section-desc">
          Cuatro pasos y ya estás practicando con simuladores reales desde tu navegador.
        </p>
      </div>

      <div class="wl-steps-wrap">
        <template v-for="(step, index) in steps" :key="step.number">
          <div class="wl-step reveal" :class="`reveal-d${index}`" :ref="registerReveal">
            <div class="wl-step-num">{{ step.number }}</div>
            <div class="wl-step-icon-box">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path v-for="(path, i) in step.icon.split('|')" :key="i" :d="path" />
              </svg>
            </div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>

          <div v-if="index < steps.length - 1" class="wl-step-arrow reveal" :class="`reveal-d${index + 1}`" :ref="registerReveal">
            <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
              <path d="M0 12h36M28 4l8 8-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
